import { Component, OnInit } from '@angular/core';
import { VERSAO_CVS } from 'src/app/services/autorizacao-api';
import { BusinessService } from '../../../services/business.service';
@Component({
  selector: 'app-footer-generic',
  templateUrl: './footer-generic.component.html',
  styleUrls: ['./footer-generic.component.scss']
})
export class FooterGenericComponent implements OnInit {

  versaoCVS: string = VERSAO_CVS;

  constructor(private businessService: BusinessService) { }

  ngOnInit() {
  }

  mostrarSeloANSCCG() {
    return (this.businessService.getBusinessId() === '8');
  }

  mostrarSeloANSClinipan() {
    return (this.businessService.getBusinessId() === '9');
  }

  mostrarSeloANSNDIMinas() {
    return (this.businessService.getBusinessId() === '10');
  }

  mostrarSeloANSHapvida() {
    return (this.businessService.getBusinessId() === '1');
  }

}
